/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react';
import {
  Box, Button, Checkbox, Container,
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import ROUTES from '../../../../Configs/routes';

export default function Component({
  classes, error, message,
}) {
  const navigate = useNavigate();

  const { openAlert } = useContext(AlertContext);

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <Box className={classes.root}>
        <Elements.Navigator title="Terms and Condition" />
        <Container sx={{ py: 3 }}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut vitae eleifend leo, non vulputate lectus. Pellentesque dictum quam at tellus scelerisque, at malesuada ante aliquam. Suspendisse pulvinar, libero vel pharetra accumsan, tellus ante pretium ipsum, nec volutpat nibh urna quis tellus. Quisque non tempor arcu. Nunc vestibulum laoreet mi, sit amet fringilla massa. Maecenas ut massa elementum, elementum sapien a, porttitor orci. Nam hendrerit, tellus sit amet aliquet rhoncus, nibh sem molestie erat, quis accumsan dui eros et est. Praesent faucibus, lorem eu aliquet convallis, lacus tortor aliquam ante, at euismod purus dolor vehicula justo. Cras ex magna, fringilla non sem at, accumsan rutrum odio. Nunc mi ante, vestibulum vel laoreet non, tristique ut est.
          Aenean mi nibh, hendrerit eu fermentum eget, euismod venenatis purus. Sed vehicula vitae ligula sed pretium. Sed eu sagittis tellus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Fusce ullamcorper metus id tortor efficitur lacinia a ornare orci. Vivamus non porttitor magna. Phasellus pretium est sit amet nisi consequat, in elementum libero mattis. Etiam suscipit dignissim eros id mollis. Mauris sed augue ut metus iaculis vulputate vel eget nibh. Phasellus ultrices ullamcorper urna vel sodales. In pellentesque eros eget augue mollis, sed mollis libero dictum. Donec metus purus, tempus in tincidunt a, vulputate et urna.
        </Container>
        <Container className="floating-action">
          <Box display="flex" alignItems="center">
            <Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 18 } }} />
            <Box className="mute s-12">
              I have read and agree with the
              {' '}
              <Box component={Link} className="link" to={ROUTES.termsConditions()} color="#38AC3D">Terms and Conditions</Box>
            </Box>
          </Box>
          <Button fullWidth variant="contained" className="btn-contained" onClick={() => navigate(`${ROUTES.wallet()}/pin`)}>Continue</Button>
        </Container>
      </Box>
    </Elements.PageBase>
  );
}
